export enum DateRange {
  MONTH = "Month",
  LIFETIME = "Lifetime",
  LAST_MONTH = "last-month",
  DENY_WAR = "Deny War",
}
